// Module
var code = `<table class="prints-list table"
       at-table
       at-list="\$ctrl.nonParametrizedPrints">
  <thead></thead>
  <tbody class="tbody">
  <tr>
    <td class="branches-list__number-column" at-title="No">
      {{\$index+1+'.'}}
    </td>
    <td at-implicit at-attribute="name" at-title="Name" at-initial-sorting="asc"></td>
    <td at-title="Status" ng-class="{'active' : item.active}">
      {{item.active ? "Active" : "Inactive"}}
    </td>
    <td class="prints-list__actions" at-title="Actions">
      <a class="btn"
         ng-if="\$ctrl.isParametrized(item)"
         ng-href="/#!/admin/prints/{{item.code}}/parameters">
        Customize
      </a>
      <a class="btn btn-primary"
         ng-href="/#!/admin/prints/{{item.code}}">
        Configure print
      </a>
    </td>
  </tr>
  </tbody>
</table>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/administration/prints/prints-list.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;